parseTokenTimezoneHH